module.exports = __webpack_public_path__ + "img/logo.b751ce5c.png";